import type { ImgHTMLAttributes, ReactNode } from 'react';

interface IPhoneFrameProps {
  src?: string;
  alt?: string;
  /** Custom screen content (e.g. a stack of screenshots toggled by opacity) instead of one <img>. */
  children?: ReactNode;
  /** Width, positioning and transforms for the whole device (styles in iphone-frame.css). */
  className?: string;
  loading?: ImgHTMLAttributes<HTMLImageElement>['loading'];
  imgClassName?: string;
}

/** Pure-CSS iPhone (Pro, Dynamic Island) frame — same device as mcdevlabs.com. */
export function IPhoneFrame({ src, alt, className = '', loading = 'lazy', imgClassName, children }: IPhoneFrameProps) {
  return (
    <div className={`iphone ${className}`}>
      <span className="iphone-btn iphone-btn-action" />
      <span className="iphone-btn iphone-btn-vol-up" />
      <span className="iphone-btn iphone-btn-vol-down" />
      <span className="iphone-btn iphone-btn-power" />
      <div className="iphone-body">
        <div className="iphone-bezel">
          <div className="iphone-screen">
            {children ?? <img src={src} alt={alt} loading={loading} className={imgClassName} />}
            <div className="iphone-island">
              <span />
            </div>
            <div className="iphone-glare" />
          </div>
        </div>
      </div>
    </div>
  );
}
